<template>
  <div>
    <img
      v-if="computedAvatarPath"
      :src="computedAvatarPath"
      :class="customClass" 
      :alt="alt"
    >
    <div
			v-else
			class="text-black flex align-items-center justify-content-center mr-2"
			:class="customClass"
			:style="`height: ${customSize}px; width: ${customSize}px; border-radius: 100%; margin:auto; font-size: ${customFont}px; background-color: ${getRandomColor};`"
		>
			<div :class="`pt-${padding} text-center`">
				{{ computedInitial }}
			</div>
		</div>
  </div>
</template>

<script>

export default {
  props: {
		data: {
			type: Object,
			default: () => {}
		},
		avatarField: String,
		customSize: {
			type: String,
			default: () => '65'
		},
		customFont: {
			type: String,
			default: () => '40'
		},
		readonly: Boolean,
		value: String,
		customClass: String,
		alt: String,
		padding: {
			type: String,
			default: () => '4'
		}
	},
	computed: {
		computedAvatarPath() {
			let avatar = this.avatarField ? this.avatarField : this.data.avatar_path
			let imageNotExist = false
			var http = new XMLHttpRequest();

			http.open('HEAD', avatar, false);
			http.send();

			imageNotExist = http.status != 404;

			return imageNotExist ? avatar : false
		},
    computedInitial() {
      let data = this.data
      let initial = 'J'

      if(data.first_name) {
        initial = data.first_name.charAt(0).toUpperCase() + data.last_name.charAt(0).toUpperCase()
      } else if(data.name) {
        initial = data.name.charAt(0).toUpperCase()
      } else if(data.title) {
				initial = data.title.charAt(0).toUpperCase()
			}

      return initial
    },
		getRandomColor() {
			// var letters = 'BCDEF'.split('');
			var letters = 'FABCD'.split('');
			var color = '#';
			for (var i = 0; i < 6; i++ ) {
					color += letters[Math.floor(Math.random() * letters.length)];
			}
			return color;
		}
	},
}
</script>